module.exports = "html {\r\n  overflow: hidden;\r\n}\r\n\r\nbody {\r\n  margin: 0 !important;\r\n}\r\n"